<template>
  <div>
    <form>
      <div>
        <p>
          <label style="float:left;" for="duplicateName">{{
            $t("sondage.name")
          }}</label>
          <b-input
            id="duplicateName"
            v-model="rowDuplicate.name"
            name="duplicateName"
            @focus="$event.target.select()"
          />
        </p>
      </div>
      <div style="text-align:left">
        <b-checkbox
          style="margin-top:10px"
          v-model="parameters.sondKeepQuestions"
          >{{ $t("duplicate.parameter.questions") }}</b-checkbox
        >
      </div>
      <div style="text-align:left">
        <b-checkbox
          v-model="parameters.sondKeepAnswers"
          :disabled="!parameters.sondKeepQuestions"
          >{{ $t("duplicate.parameter.results") }}</b-checkbox
        >
      </div>
      <div>
        <button @click.prevent="duplicateMeeting" class="is-primary button">
          {{ $t("button.sauvegarder") }}
        </button>
      </div>
    </form>
    <b-loading is-full-page :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PopupDuplicate',
  data () {
    return {
      isLoading: false,
      parameters: {
        eventKeepAttendees: false,
        eventKeepEvents: false,
        sondKeepAnswers: false,
        sondKeepQuestions: false,
        quizzKeepAnswers: false,
        quizzKeepQuestions: false,
        proKeepInventory: false,
        textKeepQuestions: false,
        brainKeepPostits: false
      },
      rowDuplicate: JSON.parse(JSON.stringify(this.row))
    }
  },
  props: {
    outil: String,
    row: Object
  },
  created () {
    let date = new Date()
    this.rowDuplicate.name = `${this.rowDuplicate.name} (${this.$i18n.t(
      'meeting.duplicate.rename'
    )} ${date.getDate()}/${date.getMonth() +
      1} ${date.getHours()}:${date.getMinutes()})`
  },
  methods: {
    duplicateMeeting (e) {
      this.isLoading = true
      this.parameters.row = this.rowDuplicate
      axios
        .post(
          `${process.env.URL_SSO_API}Duplicate/${this.outil}/${this.rowDuplicate.url_moderateur}`,
          this.parameters
        )
        .then(response => {
          this.$store.commit('MODAL_DUPLICATE', false)
          this.$store.commit(`CLEAR_SEARCH`)
          this.$store.dispatch('getSondages')
          this.isLoading = false
          this.$buefy.toast.open({
            type: 'is-success',
            message: this.$i18n.t('meeting.duplicate.success')
          })
        })
    }
  }
}
</script>
<style scoped>
.button{
  color:white;
  border-radius:0px;
  font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/sondage/components/Duplicate.vue